<template>
  <div class="form-item" v-show="item.visible">
    <el-form-item :label="item.label" :rules="rules" :prop="item.prop">
      <div class="infrared"
           v-bind:class="{ ve_disable: disabled }">
        <a @click="callApp()">
          <!--<i class="el-icon-full-screen scan" style="opacity: .5"></i>-->
          <img src="@/assets/scan.png" width="15px" style="position: relative;left: 20px" />
        </a>
        <span @click="callApp('view')">{{itemdata && regVid(itemdata)}}</span>
        <el-input v-model="itemdata" style="visibility: hidden"></el-input>
        <span style="color: rgb(198, 202, 209)" v-if="itemdata == ''">{{item.prompt || ''}}</span>
      </div>
    </el-form-item>
    <el-dialog :title="$t('app.scan_dialog_title')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :show-close="false"
               custom-class="scan-dialog"
               top="0"
               width="90%">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: 500;">{{$t('app.scan_result_total')}}: {{rfidData.length}}</span>&nbsp;
          <!--<span style="color: lawngreen;">{{$t('app.scan_result_success')}}: {{rfidData && (rfidData.length - failRfidData.length)}}</span>&nbsp;-->
          <span style="color: orangered;">{{$t('app.scan_result_fail')}}: {{failRfidData.length}}</span>

        </div>
        <div class="scan-result" v-for="data in rfidData" :key="data.vid">
          <div class="left" @click="showVid(data.vid)">
            {{data.vid && regVid(data.vid)}}
          </div>
          <div class="right">
            <span class="status">
              <i class="el-icon-delete"
                 style="font-size: 20px;"
                 :style="{color: data.code == 1 ? 'lawngreen' : 'orangered'}"
                 @click="delVid(data.vid)"></i>
              <!--<i class="el-icon-success" style="color: lawngreen;font-weight: 900;" v-if="data.code == 1"></i>-->
              <!--<i class="el-icon-error" style="color: orangered;font-weight: 900;" v-else></i>-->
            </span>
            <span class="clearVid"></span>
          </div>
        </div>
        <div v-if="!rfidData.length" class="no-data">{{$t('app.no_data')}}</div>
      </el-card>
      <div class="scan_tip" v-if="type !== 'view'">{{scanType && $t('app.' + scanType.split('.')[0] + '_msg')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7" v-if="isIos ||  scanSelect.indexOf('qr') > -1">
            <el-button @click="Add"
                       size="small"
                       round
                       :disabled="disabled"
                       class="btn-white-color">{{$t('app.btn_add')}}</el-button>

          </el-col>
          <el-col :span="isIos ||  scanSelect.indexOf('qr') > -1 ? 7 : 11">
             <el-button @click="clear"
                        size="small"
                        round
                        class="btn-white-color">{{$t('app.btn_clear')}}</el-button>
          </el-col>
          <el-col :span="isIos ||  scanSelect.indexOf('qr') > -1 ? 7 : 11">
            <el-button class="btn-black-color"
                       v-if="failRfidData.length"
                       round
                       @click="delAllFailData"
                       size="small">{{$t('app.del_all')}}</el-button>
             <el-button class="btn-black-color"
                        v-if="!failRfidData.length"
                        round
                        :disabled="disabled"
                        @click="confirm"
                        size="small">{{$t('app.btn_confirm')}}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog title="Choose Data Source"
               width="90%"
               top="20vh"
               :visible.sync="dialogSourceVisable">
      <el-radio-group v-model="currentSource" size="small" class="old-component-radio-group">
        <div v-for="dataSource in item.dataSource"
             style="line-height: 32px;"
             :key="dataSource">
          <el-radio :label="dataSource">{{dataSource}}</el-radio>
        </div>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 60px;">
          <el-col :span="11">
            <el-button @click="currentSource='';dialogSourceVisable=false"
                       size="small"
                       round
                       class="btn-white-color">Clear</el-button>
          </el-col>
          <el-col :span="11">
            <el-button class="btn-black-color"
                       round
                       :disabled="!currentSource"
                       @click="selectDataSource"
                       size="small">Continue</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog :title="$t('app.choose_dialog_title')"
               top="20vh"
               width="90%"
               :visible.sync="dialogChooseVisable">
      <div v-for="scan in scanSources"
           @click="selectScan(scan)"
           :class="{ 'active-selected-scan': selectType === scan.value }"
           class="scan-item">
        {{$t(`app.${scan.text}`)}}
        <span :class="{ 'el-icon-check': selectType === scan.value }"></span>
      </div>
      <el-radio-group v-model="selectNum"
                      size="small"
                      v-if="selectType && scanColl[selectType] && scanColl[selectType].length > 1" class="old-component-radio-group">
          <el-radio v-for="type in scanColl[selectType]"
                    style="line-height: 24px;"
                    :key="type"
                    :label="type">{{$t(`app.${type}`)}}</el-radio>
      </el-radio-group>
      <el-radio-group size="small" v-if="!selectType" class="old-component-radio-group">
        <el-radio style="line-height: 24px;" label="single" disabled>{{$t('app.single')}}</el-radio>
        <el-radio style="line-height: 24px;" label="multi" disabled>{{$t('app.multi')}}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 20px;">
          <el-col :span="11">
            <el-button @click="dialogChooseVisable = false"
                       size="small"
                       round
                       class="btn-white-color">{{$t('app.btn_clear')}}</el-button>
          </el-col>
          <el-col :span="11">
            <el-button class="btn-black-color"
                       round
                       :disabled="!selectNum || !selectType"
                       @click="confirmSelect"
                       size="small">{{$t('app.btn_save')}}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
        title="VID"
        :visible.sync="centerDialogVisible"
        width="70%"
        center>
      <span>{{currentVid}}</span>
    </el-dialog>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex'
	import utils from '@/utils'
	import callApp from '@/services/sdk'
	export default {
		name: 'vid-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object },
			value: [String, Object, Array]
		},
		data() {
			return {
				flag: 0,
				currentVid: '',
				rules: utils.generateFormRule(this.item),
				centerDialogVisible: false,
        type: '',
				dialogVisible: false,
				rfidData: [],
				failRfidData: [],
				scanSources: [],
				dialogChooseVisable: false,
				dialogSourceVisable: false,
				scanSelect: '',
        selectType: '',
        selectNum: 'single',
        scanColl: {},
				currentSource: 'local.scanner',
				isIos: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
			}
		},
		computed: {
			...mapGetters({
        scanType: 'getCurrentScanType',
        formStatus: 'getFormStatus',
        bigVid: 'getBigVid',
        dataPointType: 'getDataPointType'
			}),
      currentType() {
				return this.dataPointType === 'collectionUnBind'
        || this.dataPointType === 'collectionBind'
          ? ( (this.item.name || '').toLowerCase() === 'bigvid'
            ? 'bigvid'
            : 'subvid' )
          : ''
      },
      disabled() {
				return (this.formStatus === 'submitedit'
          && (this.dataPointType === 'bind'
            || this.dataPointType === 'collectionUnBind'
            || this.dataPointType === 'collectionBind')
          || !this.item.editable
          // || (this.currentType === 'subvid' && !this.bigVid)
        )
      },
			itemdata: {
				get() {
					if (this.value && this.value.vidlist) {
						this.rfidData = this.value.vidlist.map(vid => {
							return {
								vid: vid,
                code: 1
              }
            })
            if (this.item.max === 1) return this.value.vidlist[0]
            return this.value.vidlist.length ? this.value.vidlist.length: ''
					} else {
						return ''
          }
        },
				set(itemdata) {
					if (!itemdata) return this.$emit('input', '')
					let data = {
						vidlist: itemdata ? this.rfidData.map(data => data.vid) : [],
						type: 0
					}
					this.$emit('input', data)
				}
			}
		},
		watch: {
			'bigVid': function () {
				// this.flag++
        // this.$nextTick(() => {
				// 	if (this.formStatus !== 'init' && this.flag > 1) {
				// 		if (this.currentType === 'subvid') {
				// 			this.rfidData = []
				// 			this.failRfidData = []
				// 			this.$nextTick(() => {
				// 				this.itemdata = ''
				// 			})
				// 		}
				// 	}
        //
				// })
      }
		},
		created() {
			const _this = this
			this.$store.state.vidlistComponents.push(this) // 缓存vid组件实例
      window['web.closeScanDialog'] = () => {
				this.$store.state.vidlistComponents.forEach(instance => { // 切换扫描类别时, 关闭扫描的弹窗
					instance.dialogVisible = false
				})
      }
			window['web.setVidSource'] = () => {
				this.scanColl = {}
				callApp('getVidSource', {
					type: 'device.vidSource',
					data: {
						max: this.item.max
					}
				}, 'cbGetVidSource').then(data => {
					this.$store.state.vidlistComponents.forEach(instance => { // 切换扫描类别时, 关闭扫描的弹窗
						instance.dialogVisible = false
					})
          if (this.scanSelect) {
						this.selectType = this.scanSelect.split('.')[0]
						this.selectNum = this.scanSelect.split('.')[1]
					}
					this.scanSources = data.vidSources.map(item => {
						let scan = item.split('.')
						if (this.scanColl[scan[0]]) {
							this.scanColl[scan[0]].push(scan[1])
						} else {
							this.scanColl[scan[0]] = [scan[1]]
							return { text: scan[0], value: scan[0]}
						}
					}).filter(item => item !== undefined)
					this.$nextTick(_ => {
						_this.dialogChooseVisable = true
					})
				})
			}
			callApp('getSelectedVidSource', {
				type: 'storage.getSelectedVidSource',
				data: {}
			}, 'cbGetSelectedVidSource').then(data => {
				this.selectType = data.split('.')[0]
				this.selectNum = data.split('.')[1]
				this.scanSelect = data
				this.$store.dispatch('setCurrentScanType', data)
			})
			// let interval = setInterval(() => {
			// 	if (!this.isExisted(this.rfidData, {vid: 12312332, status: Math.random() > .5 ? 1 : 0})) {
			// 	this.rfidData.push({vid: 12312332, status:  Math.random() > .5 ? 1 : 0})
			// }
			// let scanCardDom = 	document.querySelector('.box-card .el-card__body')
			// scanCardDom.scrollTop = scanCardDom.scrollHeight - scanCardDom.offsetHeight + 40
			//   if (this.rfidData.length === 5) {
			// 	clearInterval(interval)
			//   }
			// }, 1000)
		},
    mounted() {
			let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
			let name = `form[${this.item.uuid}]`

			this.$refs[name] && result.push(this.$refs[name])
			this.$store.dispatch('setFormSet', result)
	  this.solveBigVid()
	  
	  if (this.item.max === 1) { // 这边处理的原因是因为 confirm 后，页面上绑定的itemdata不会触发get钩子
					if (result.length === 1) {
						this.itemdata = result[0]
					} else if (result.length > 1) {
						this.itemdata = result.length
					} else {
						this.itemdata = ''
					}
        } else {
					this.itemdata = result.length || ''
		}
    },
		methods: {
			showVid(vid) {
				this.currentVid = vid
				this.centerDialogVisible = true
      },
			regVid(vid) {
				if (!vid || typeof vid !== 'string'|| vid.length < 6) return vid
				return vid.replace(vid.substring(6, vid.length - 6), '......')
      },
			Add() {
				this.callBack()
			},
			delAllFailData() {
				this.failRfidData = []
				this.rfidData = this.rfidData.filter(vid => vid.code == 1)
      },
			delVid(vid) {
				if (this.disabled) return
				let totalIndex
				let failIndex
				this.rfidData.forEach((item, index) => {
					if (item.vid === vid) {
						totalIndex = index
					}
				})
				this.failRfidData.forEach((item, index) => {
					if (item.vid === vid) {
						failIndex = index
					}
				})
				if (totalIndex !== undefined) {
					this.rfidData.splice(totalIndex, 1)
				}
				if (failIndex !== undefined) {
					this.failRfidData.splice(failIndex, 1)
				}
			},
			clear() {
				// 取消后先清空当前显示数据，再从已经选中的数据中装值
				this.rfidData = []
				this.failRfidData = []
				if (this.value && this.value.vidlist) { // 关闭之后要同步一下当前select 的value
					this.rfidData = this.value.vidlist.map(vid => {
						return {
							vid: vid,
							code: 1
						}
					})
				}
				this.dialogVisible = false
				callApp('getData', {
					type: `device.closeScan`,
					data: this.scanType
				}, 'cbGetData')
			},
			confirm() {
				let result = []
				this.rfidData.forEach(item => {
					if (item.code === 1) {
						result.push(item.vid)
          }
        })
        if (this.item.max === 1) { // 这边处理的原因是因为 confirm 后，页面上绑定的itemdata不会触发get钩子
					if (result.length === 1) {
						this.itemdata = result[0]
					} else if (result.length > 1) {
						this.itemdata = result.length
					} else {
						this.itemdata = ''
					}
        } else {
					this.itemdata = result.length || ''
		}

				this.$nextTick(() => {
					this.solveBigVid()
				})
				this.dialogVisible = false
				callApp('getData', {
					type: `device.closeScan`,
					data: this.scanType
				}, 'cbGetData')
			},
			isExisted(ary, item) {
				let flag
				ary.forEach((data, index) => {
					var dataVid = data.vid && data.vid.toLowerCase()
					var itemVid = item.vid && item.vid.toLowerCase()
					if (dataVid === itemVid) {
						flag = index
						this.$set(ary, index, item) // 重复的vid会被覆盖
					}
				})
				return flag !== undefined
			},
      selectScan(scan) {
				this.selectType = scan.value
        this.selectNum = 'single'
      },
			confirmSelect() {
				this.scanSelect = this.selectType + '.' + this.selectNum
        this.$nextTick(() => {
					callApp('updateSelectedVidSource', {
						type: 'storage.updateSelectedVidSource',
						data: this.scanSelect
					}, 'cbUpdateSelectedVidSource').then(data => {
						this.dialogChooseVisable = false
						this.$store.dispatch('setCurrentScanType', this.scanSelect)
					})
        })
			},
			selectDataSource() {
				this.dialogSourceVisable = false
				this.callApp()
      },
      createRandom() {
        return +new Date() + Math.random().toString().substr(2, 4)
      },
      callBack() {
				this.dialogVisible = true
				const requestId = this.createRandom()
        const bigVid = this.currentType === 'subvid' ? this.bigVid : void 0
				callApp('getData', {
					type: `dataSource.${this.scanType}`,
					data: {
						max: this.item.max - this.rfidData.length,
						bigVid
          }
				}, 'cbGetData', '', requestId)
					.then(data => {
						if (!this.isIos) { // 安卓因为多扫，所以扫描的逻辑不同
							window['web.setVidData' + requestId] = (data) => {
								if (this.item.max - (this.rfidData.length + data.length) < 0) {
									this.$toast({
										message: this.$t('app.scan_limit'),
										position: 'center',
										iconClass: 'icon el-icon-warning',
										duration: '3000'
									})
									return
								}
								if (this.item.max > 1) {
									data.vids.forEach((item) => {
										// if (this.rfidData.length === this.item.max){
										// 	this.$message.warning('the scan number has reached to the upper limit')
										// 	return
										// }
										if (item.vid && !this.isExisted(this.rfidData, item)) { // all, 重复的vid会被覆盖
											this.rfidData.push(item)
											if (item.code != 1) { //record fail
												this.failRfidData.push({vid: item.vid, key: Math.random()})
											}
										} else {
											let index
											if (item.code == 1) {
												this.failRfidData.filter((data, i) => {
													if (data.vid === item.vid) {
														index = i
                          }
                        })
                      }
                      index !== undefined && this.failRfidData.splice(index, 1)
                    }
									})
									let scanCardDom = 	document.querySelector('.box-card .el-card__body')
									scanCardDom.scrollTop = scanCardDom.scrollHeight - scanCardDom.offsetHeight + 40
								} else {
									this.rfidData = data.vids
									this.failRfidData = data.vids.filter(vid => vid.code != 1)
								}
							}

						} else { // ios逻辑
							if (this.item.max > 1) {
								data.vids.forEach((item) => {
									// if (this.rfidData.length === this.item.max){
									// 	this.$message.warning('the scan number has reached to the upper limit')
									// 	return
									// }
									if (item.vid && !this.isExisted(this.rfidData, item)) { // all, 重复的vid会被覆盖
										this.rfidData.push(item)
										if (item.code != 1) { //record fail
											this.failRfidData.push({vid: item.vid, key: Math.random()})
										}
									} else {
										let index
										if (item.code == 1) {
											this.failRfidData.filter((data, i) => {
												if (data.vid === item.vid) {
													index = i
												}
											})
										}
										index !== undefined && this.failRfidData.splice(index, 1)
									}
								})
								let scanCardDom = 	document.querySelector('.box-card .el-card__body')
								scanCardDom.scrollTop = scanCardDom.scrollHeight - scanCardDom.offsetHeight + 40
							} else {
								this.rfidData = data.vids
								this.failRfidData = data.vids.filter(vid => vid.code != 1)
							}
						}
					})
      },
			callApp(type) {
				if (this.disabled && !type) {
					return
        }
				if (!this.currentSource) {
					this.dialogSourceVisable = true
				} else {
					// this.rfidData = []
					// this.failRfidData = []
					if (this.currentSource.toLowerCase().indexOf('local.scanner') > -1) { // scanner
						if (!this.scanType) {
							this.scanColl = {}
							callApp('getVidSource', {
								type: 'device.vidSource',
								data: {
									max: this.item.max
                }
							}, 'cbGetVidSource').then(data => {
								this.scanSources = data.vidSources.map(item => {
									let scan = item.split('.')
									if (this.scanColl[scan[0]]) {
										this.scanColl[scan[0]].push(scan[1])
									} else {
										this.scanColl[scan[0]] = [scan[1]]
										return { text: scan[0], value: scan[0]}
									}
								}).filter(item => item !== undefined)
								this.$nextTick(_ => {
									this.dialogChooseVisable = true
								})
							})
							return
						}
						this.dialogVisible = true
            if (type === 'view') {
							this.type = 'view'
              return
            }
            this.type = ''
						this.callBack()
          } else {
						callApp('getData', {
							type: this.currentSource,
							data: { max: this.item.max, min: this.item.min }
						}, 'cbGetData')
          }
        }
			},
      solveBigVid() {
				if (this.currentType === 'bigvid') {
					this.$store.dispatch('setBigVid', this.itemdata)
        }
      }
		}
	}
</script>
<style lang="stylus">
    .scan-item
      line-height 40px
      border-bottom 1px solid #e8e8e8
    .active-selected-scan
      font-weight 500
      color #000000
      span
        display inline-block
        float right
        line-height 40px
        font-weight 700
		.old-component-radio-group
			display block
			margin-top 30px
			text-align center
			.el-radio__input.is-checked .el-radio__inner
				border-color #000
				background #000
			.el-radio__input.is-checked+.el-radio__label
				color #000
    .nfc
    .infrared
    .deviceTime
    .gps
      height 40px
      border-radius 4px
      border 1px solid #DCDFE6
      padding-left 14px
      word-break break-word
      overflow hidden
      padding-right 6px
      a {
        float right
        display inline-block
        width 40px
        height 40px
        position relative
      }
      span {
        display inline-block
        height 100%
        width calc(100% - 45px)
      }
      &:active {
        border-color #409eff
      }
      .scan
        position absolute
        right 4px
        top 14px
    .ve_disable
      &:active {
        border-color #DCDFE6
      }
    .scan_tip
      margin-top 10px
      text-align center
      opacity .8
    .box-card
      .el-card__body
        height calc(100vh - 360px)
        overflow-y scroll
        .no-data
          text-align center
          opacity .5
        .scan-result
          padding 10px 0px
          display flex
          justify-content space-between
          border-bottom 1px solid lightgrey
          .left
            word-break break-word
          .right
            text-align right
            width 90px
</style>

